import React from "react";
import ReactDOM from "react-dom";
import LoginPrompt from "../widgetComponents/loginPrompt/login-prompt";

ReactDOM.render(<LoginPrompt />, document.querySelector("#LoginPrompt"));
